import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  UPDATE_SELECTED_ITEMS,
  SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED,
  SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS,
  DOWNLOAD_PREVIEW_REQUESTED,
  DOWNLOAD_PREVIEW_SUCCESS,
  FIND_BARCODE_VALUE_IMAGE_REQUESTED,
  FIND_BARCODE_VALUE_IMAGE_SUCCESS,
  GET_PRODUCT_CUSTOM_FIELDS_REQUESTED,
  GET_PRODUCT_CUSTOM_FIELDS_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  searchedBrands: {},
  searchedProducts: null,
  searchedProductsPagination: null,
  searchedVariants: null,
  searchedBarcodes: [],
  searchingBarcodes: [],
  missingBarcodes: [],
  activeBarcode: null,
  sessionProductActions: [],
  batchProductActions: [],
  loadingCustomFields: [],
  customFields: [],
  missingCustomFields: [],
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  printable: 'false',
  selectedProductList: { variations: {}, products: {} },
  downloadUrl: null,
  errors: null
};

const products = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case SEARCH_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedProducts: null,
        searchedProductsPagination: null,
        searchedVariants: null,
        searchedBarcodes: [],
        searchingBarcodes: [],
        missingBarcodes: []
      });

    case SEARCH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        searchedBrands: action.payload.brands,
        searchedProducts: action.payload.products,
        searchedProductsPagination: action.payload.product_pagination,
        searchedVariants: action.payload.variants,
        // searchedBarcodes: action.payload.barcodes,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case UPDATE_SELECTED_ITEMS:
      return Object.assign({}, state, {
        selectedProductList: action.payload
      });

    case SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedProducts: null,
        searchedProductsPagination: null,
        searchedVariants: null
      });

    case SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS:
      return Object.assign({}, state, {
        activeBarcode: action.payload.barcode_value_item_data,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case DOWNLOAD_PREVIEW_REQUESTED:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'requesting_preview',
        downloadUrl: null,
      });

    case DOWNLOAD_PREVIEW_SUCCESS:
      return Object.assign({}, state, {
        downloadUrl: action.payload.preview_url,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case FIND_BARCODE_VALUE_IMAGE_REQUESTED:
      return Object.assign({}, state, {
        searchingBarcodes: [...state.searchingBarcodes, action.payload]
      });

      // TODO: this breaks with lots of items, find another way to do missing barcodes
    case FIND_BARCODE_VALUE_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        searchingBarcodes: state.searchingBarcodes.filter(item => item !== action.payload.found_barcode_value && item !== action.payload.missing_barcode_value),
        searchedBarcodes: [...state.searchedBarcodes, action.payload.found_barcode_value].filter(item => item),
        missingBarcodes: [...state.missingBarcodes, action.payload.missing_barcode_value].filter(item => item)
      });


    case GET_PRODUCT_CUSTOM_FIELDS_REQUESTED:
      return Object.assign({}, state, {
        loadingCustomFields: [...state.loadingCustomFields, action.payload]
      });


    case GET_PRODUCT_CUSTOM_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        loadingCustomFields: state.loadingCustomFields.filter(item => item !== action.payload.product_id),
        customFields: [...state.customFields, action.payload].filter(item => item)
      });

    default:
      return state;
  }
}

export default products;
